/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Detail_Label_Source_Pxk_ScentingInputs */

const vi_sl_detail_label_source_pxk_scenting = /** @type {(inputs: Sl_Detail_Label_Source_Pxk_ScentingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiếu xuất lô phân loại (nguồn)`)
};

/**

* @param {Sl_Detail_Label_Source_Pxk_ScentingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_detail_label_source_pxk_scenting = /** @type {((inputs?: Sl_Detail_Label_Source_Pxk_ScentingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Detail_Label_Source_Pxk_ScentingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_detail_label_source_pxk_scenting(inputs)
});